
export enum PaymentServiceProvider {
    None = 0,
    Stripe = 1,
    Chase = 2
}
export enum PaymentServiceProviderMethod {
    ApplePay = 1,
    GooglePay = 2,
    AddCard = 3
}
export class UserPaymentProvider {
    addCard: PaymentServiceProvider;
    applePay: PaymentServiceProvider;
    googlePay: PaymentServiceProvider;
}
  
export interface PaymentMethodRequest extends PaymentTypeRequest {
    isDefault: boolean;
    isAutoReload: boolean;
  }

  export interface PaymentPayloadResponse {
    paymentMethodRequest: PaymentMethodRequest;
    canEncryptCard: boolean;
  }

  export interface PaymentTypeRequest {
    paymentType: string;
    token? : string | null;
    paymentToken?: PaymentToken;
    'x-coordinates'?: string;
  }
  export interface PaymentToken {
    token?: string;
    cardBrand?: PaymentCardType2;
    cardLastFour?: string;
    paymentServiceProvider: PaymentServiceProvider;
    paymentType: PaymentType;
    cardInfo?: CardInfo;
    devicePaymentData?: string;
    chaseEncryptedCardData?: EncryptedCardData;
    fraudDataCollectorSessionId?: string;
    lineItems?: any;
  }
  export interface EncryptedCardData {
    encryptedCardNumber: string;
    encryptedCVV: string;
    integrityCheckValue: string;
    keyId: string;
    phase: number;
    mode: EncryptionMode;
    format: string;
  }
  export enum EncryptionMode {
    FPE = 1,
    eFPE = 2
  }
  export enum PaymentType {
    Giftcard = 1,
    Paypal = 2,
    Card = 3,
    ApplePay = 4,
    AndroidPay = 5,
    PaypalBrainTree = 7,
    Paze = 9
  }
  
  export enum PaymentCardType {
    Cash = 1,
    CreditCards = 2,
    visa = 3,
    Visa = 3,
    mastercard = 4,
    americanexpress = 5,
    amex = 5,
    AmericanExpress = 5,
    discover = 6,
    CarteBlanche = 7,
    dinersclub = 8,
    diners = 8,
    Check = 9,
    TravelersCheck = 10,
    GiftCertificates = 11,
    HouseAccount = 12,
    Waste = 13,
    GiftCard = 14,
    giftcard = 14,
    DebitCards = 15,
    ChargeSale = 16,
    CollegeBucks = 17,
    PayPal = 18
  }
  export enum PaymentCardType2 {
		Visa = 1,
    visa = 1, 
		Amex = 2,
    amex = 2,
    mastercard = 3,
		MasterCard = 3,
		Discover = 4,
    discover = 4,
		Jcb = 5,
    jcb =5,
		DinersClub = 6,
    dinersclub = 6,
		Unknown = 7,
    unknown = 7	
  }
  export enum CardBrandTypeString {
    Visa = 'visa',
    Mastercard = 'mastercard',
    Amex = 'amex',
    AmericanExpress = 'american express',
    Discover = 'discover',
    Dinersclub = 'dinersclub',
    Diners = 'diners',
    DinersClub = 'diners club',
    Generic = 'generic'
  }
  
  export enum PaymentCardTypeString {
    'Cash' = 1,
    'CreditCards' = 2,
    'Visa' = 3,
    'visa' = 3,
    'mastercard' = 4,
    'MasterCard' = 4,
    'americanexpress' = 5,
    'amex' = 5,
    'AmericanExpress' = 5,
    'discover' = 6,
    'Discover' = 6,
    'CarteBlanche' = 7,
    'dinersclub' = 8,
    'DinersClub' = 8,
    'Check' = 9,
    'TravelersCheck' = 10,
    'GiftCertificates' = 11,
    'HouseAccount' = 12,
    'Waste' = 13,
    'GiftCard' = 14,
    'giftcard' = 14,
    'DebitCards' = 15,
    'ChargeSale' = 16,
    'CollegeBucks' = 17,
    'PayPal' = 18,
    'paypal' = 18,
    'cash' = 1,
    'creditcards' = 2,
    'paze' = 2,
    'carteblanche' = 7,
    'check' = 9,
    'travelerscheck' = 10,
    'giftcertificates' = 11,
    'houseaccount' = 12,
    'waste' = 13,
    'debitcards' = 15,
    'chargesale' = 16,
    'collegebucks' = 17
  }
  
  export enum PaymentTypeString {
    Paypal = 'paypal',
    Card = 'card',
    ApplePay = 'applepay',
    Giftcard = 'giftcard',
    AndroidPay = 'googlepay',
    PaypalBrainTree = 'paypalbraintree',
    Paze = 'paze',
    GiftCardPay = 'giftcardpay'
  }
  
export class CardInfo {
    public id: string;
    public name?: string;
    public number: string;
    public expirationMonth?: string;
    public expirationYear?: string;
    public zipCode?: string;
    public brand?: string; 
    public paymentServiceProvider?: PaymentServiceProvider; 
    public cardBrand?: PaymentCardType2;
  }
  
  export class PaymentInfo {
    public paymentType: string;
    public cardInfo?: CardInfo | null;
    public isDefault?: boolean | null;
    public isAutoReload?: boolean | null;
  }
  
  export class PaymentsModel {
    public payments?: (PaymentInfo[]) | null;
  }

  export enum PickupPath {
    Delivery = 1,
    Pickup = 2
  }